import { useFormik } from "formik";
import { Alert, Box, Button, FormControl, Grid, TextField } from "@mui/material";
import { Iconify } from "../../common/iconify";
import TipoEventosService from "../../services/TipoEventoService";
import { useState } from "react";
import { TipoEvento } from "../../types/TipoEvento/TipoEvento";
import { validationTipoEvento } from "../validationsForm/ValidationTipoEventoSchema";

interface Props {
    tipo: TipoEvento;
    onResponse?: (dataRespuesta: any) => void
}

export const TipoEventoForm: React.FC<Props> = ({ tipo, onResponse }) => {
    const [textoError, setTextoError] = useState('');

    const formik = useFormik<TipoEvento>({
        initialValues: {
            ...tipo,
            estado: 'A',
        },
        validationSchema: validationTipoEvento,
        onSubmit: (values) => {
            if(values.idTipoEvento === 0){
                Guardar(values)
            }else{
                Editar(values)
            }
            
        }
    });

    async function Guardar(tipo: TipoEvento){
        setTextoError('');
        await TipoEventosService.CrearTipoEvento(tipo)
        .then(data => {
            if(data.status.isSuccessfully){
                if(onResponse){
                    onResponse(data.statusCode)
                }
            }else{
                setTextoError('No pudo guardarse')
                console.error(data.status)
            }
        }).catch(error => {
            setTextoError('No pudo guardarse')
            console.error(error)
        })
    }

    async function Editar(tipo: TipoEvento){
        setTextoError('');
        await TipoEventosService.EditarTipoEvento(tipo)
        .then(data => {
            if(data.status.isSuccessfully){
                if(onResponse){
                    onResponse(data.statusCode)
                }
            }else{
                setTextoError('No pudo guardarse')
                console.error(data.status)
            }
        }).catch(error => {
            setTextoError('No pudo guardarse')
            console.error(error)
        })
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container direction={'row'} spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={Boolean(formik.errors.txtNombre && formik.touched.txtNombre)}>
                        <TextField
                            fullWidth
                            id="txtNombre"
                            name="txtNombre"
                            label="Nombre"
                            value={formik.values.txtNombre}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.txtNombre && Boolean(formik.errors.txtNombre)}
                            sx={{ marginBottom: '20px', width: '100%' }}
                        />
                        {formik.touched.txtNombre && formik.errors.txtNombre && (
                            <Alert severity="error">{formik.errors.txtNombre}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={Boolean(formik.errors.txtDescripcion && formik.touched.txtDescripcion)}>
                        <TextField
                            multiline
                            rows={2}
                            id="txtDescripcion"
                            name="txtDescripcion"
                            label="Descripción"
                            value={formik.values.txtDescripcion}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.txtDescripcion && Boolean(formik.errors.txtDescripcion)}
                            sx={{ marginBottom: '20px', width: '100%' }}
                        />
                        {formik.touched.txtDescripcion && formik.errors.txtDescripcion && (
                            <Alert severity="error">{formik.errors.txtDescripcion}</Alert>
                        )}
                    </FormControl>
                </Grid>
                {textoError !== '' ? <Alert severity="error">{textoError}</Alert> : <></>}
                <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" justifyContent="flex-end">
                        <Button type="submit" size="large" variant="contained" color='primary' endIcon={<Iconify icon={"material-symbols:save-outline"} />}>
                            Guardar
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
}